import {toast} from "react-toastify"
import {formatDate} from "../utils/helper"

const SubscriptionItem = ({account}) => {
    return (
        <div className="subscription-subscriptionobject">
        <div className="subscription-container08">
          <h3 className="subscription-text03">account_id</h3>
          <span className="subscription-text04">{account.account_id}</span>
        </div>
        <div className="subscription-container09">
          <h3 className="subscription-text05">name</h3>
          <span className="subscription-text06">{account.name}</span>
        </div>
        <div className="subscription-container10">
          <h3 className="subscription-text07">Phone Number</h3>
          <span className="subscription-text08">{account.phone_number}</span>
        </div>
        <div className="subscription-container11">
          <h3 className="subscription-text09">Expires On</h3>
          <span className="subscription-text10">{formatDate(account.subscription.expires_on)}</span>
        </div>
        <div className="subscription-container12">
          <h3 className="subscription-text11">Status</h3>
          <span className="subscription-text12">{account.subscription.status}</span>
        </div>
        <div className="subscription-container13">
          <button type="button" className="subscription-button2 button" onClick={() => {
            toast.success("Subscription Cancelled Successfully");
          }}>
            Cancel Subscription
          </button>
        </div>
      </div>
    )
  }
  
  
  export default SubscriptionItem;
  